<template>
  <v-layout row wrap>
    <Stock v-for="stk in stocks" :key="stk.id" :stock="stk"/>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Stock from './Stock'

export default {
  components: { Stock },
  computed: {
    ...mapGetters({
        stocks: 'stockPortfolio'
    })
  }
}
</script>

<style>

</style>